module.exports = __webpack_public_path__ + "img/Ensino-Personalizado-1100x350.c1d5b4ff.png";